import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { MasterService } from '../service/master.service';
import { UsersService } from '../service/users.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'contract-company-list-app',
    templateUrl: './contract-company-list.component.html',
    styleUrls: ['contract-company.component.css']
})
export class ContractCompanyListComponent implements OnInit {
    @Input() event_id: number;
    title : string = '契約会社マスタ(システム管理)';
    page : number = 1;
    isLoaded : boolean = false;
    selected : boolean = false;
    datalist : any = [];

    constructor(
        private commonService: CommonService,
        private masterService: MasterService,
        private usersService: UsersService,
        private router: Router,
        private location: Location,
    ) { }

    select_data:any=[];
        
    ngOnInit(): void {
        this.getList();
        //画面上部へ移動
        window.scrollTo(0, 0);
    };
    clearData (): void{
        this.isLoaded = false;
        this.select_data = {};
        this.editSelectRowData(undefined);
        this.selected = false;
        this.datalist = [];
    }

    getList(): void {
        this.clearData();
        this.masterService.getContractCompany(9)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.datalist= res["fuel_results"];
                for (let i = 0; i < this.datalist.length; i++) {
                    this.datalist[i]['password_change_flg'] = this.commonService.exchange01toTF(this.datalist[i]['password_change_flg']);
                    this.datalist[i]['password_complexity_flg'] = this.commonService.exchange01toTF(this.datalist[i]['password_complexity_flg']);
                    this.datalist[i]['monsin_contract_flg'] = this.commonService.exchange01toTF(this.datalist[i]['monsin_contract_flg']);
                    this.datalist[i]['yoyaku_contract_flg'] = this.commonService.exchange01toTF(this.datalist[i]['yoyaku_contract_flg']);
                    this.datalist[i]['option_mendan_flg'] = this.commonService.exchange01toTF(this.datalist[i]['option_mendan_flg']);
                    this.datalist[i]['adminlist']['mendan_ishi_flg'] = this.commonService.exchange01toTF(this.datalist[i]['adminlist']['mendan_ishi_flg']);
                }
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    checkData():boolean{
        if (this.select_data.code == null || this.select_data.code == "" || this.select_data.code.length > 10 || 
            this.select_data.name == null || this.select_data.name == "" || this.select_data.name.length > 128 || 
            this.select_data.name_short == null || this.select_data.name_short == "" || this.select_data.name_short.length > 128 || 
            this.select_data.representative == null || this.select_data.representative == "" || this.select_data.representative.length > 64 || 
            this.select_data.tel == null || this.select_data.tel == "" || this.select_data.tel.length > 15 || 
            this.select_data.mail_from == null || this.select_data.mail_from == "" || this.select_data.mail_from.length > 64 || 
            this.select_data.mail == null || this.select_data.mail == "" || this.select_data.mail.length > 128 || 
            this.select_data.mail2 == null || this.select_data.mail2 == "" || this.select_data.mail2.length > 128 || 
            this.select_data.mail_bcc == null || this.select_data.mail_bcc == "" || this.select_data.mail_bcc.length > 128 || 
            this.select_data.zip == null || this.select_data.zip == "" || this.select_data.zip.length > 7 || 
            this.select_data.address1 == null || this.select_data.address1 == "" || this.select_data.address1.length > 128||
            this.select_data.mendan_mail == null || this.select_data.mendan_mail == "" || this.select_data.mendan_mail.length > 128 
        )
        {
            return false;
        }else{

            var row = this.select_data.adminlist.filter(
                item => 
                    item.m_person_name == "" || item.m_person_name == null
              );  
            if (row.length > 0) {
                return false;
            } else{
                return true;
            }
        }
    }
    save():void{this.commonService.modalOpens(50001,
        //保存してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                this.select_data.password_change_flg = this.commonService.exchangeTFto01(this.select_data.password_change_flg);
                this.select_data.password_complexity_flg = this.commonService.exchangeTFto01(this.select_data.password_complexity_flg);
                this.select_data.monsin_contract_flg = this.commonService.exchangeTFto01(this.select_data.monsin_contract_flg);
                this.select_data.yoyaku_contract_flg = this.commonService.exchangeTFto01(this.select_data.yoyaku_contract_flg);
                this.select_data.option_mendan_flg = this.commonService.exchangeTFto01(this.select_data.option_mendan_flg);

                this.masterService.setContractCompany(this.select_data)
                .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10001,modalresult=>{
                                if (modalresult == "OK"){
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.getList();
                                }
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });
                
            }else{
                //
            }
        }
    );
    }
    cancel():void{
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
                 modalresult => {
                    if (modalresult == "OK"){
                        this.editSelectRowData(undefined);
                        this.selected = false;
                    }else{
    
                    }
                }
            );
    }
    pw_reset(row:any){
        this.commonService.modalOpens(50011,
            //パスワード初期化してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.usersService.resetPassword(row)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10006,modalresult=>{
                                    if (modalresult == "OK"){
                                        row.password = res["fuel_results"];
                                    }
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });                    
                }else{
                    //
                }
            }
        );
    }
    delete():void{
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.masterService.deleteContractCompany(this.select_data)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002,modalresult=>{
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    }else{

                }
            }
        );
    }

    // 編集
    edit(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }
    editSelectRowData(row: any): void {

        if (row == undefined){
            this.selected = true;
            this.select_data = { 
                id: null,
                code: null,
                name: null,
                name_short: null,
                representative: null,
                tel: null,
                mail_from: null,
                mail: null,
                mail2: null,
                mail_bcc: null,
                zip: null,
                address1: null,
                address2: null,
                address3: null,
                mendan_mail:null,
                update_datetime:null,
                adminlist:[
                    { m_user_id: null,
                        users_account: null,
                        m_person_name: null,
                        group:999,
                        mendan_ishi_flg:false
                    },
                    { m_user_id: null,
                        users_account: null,
                        m_person_name: null,
                        group:2,
                        mendan_ishi_flg:false
                    },
                    { m_user_id: null,
                        users_account: null,
                        m_person_name: null,
                        group:2,
                        mendan_ishi_flg:false
                    }
                ],
                password_change_flg:false,
                password_complexity_flg:false,
                password_lock_count:10,
                password_expire_days:90,
                monsin_contract_flg:false,
                yoyaku_contract_flg:false,
                option_mendan_flg:false,
            };
        }else{
            this.selected = true;
            this.select_data = JSON.parse(JSON.stringify(row))
            for (let i = 0; i < this.select_data.adminlist.length; i++) {
                if(this.select_data.adminlist[i]['mendan_ishi_flg'] ==1){
                    this.select_data.adminlist[i]['mendan_ishi_flg'] = this.commonService.exchangeTFto01(this.select_data.adminlist[i]['mendan_ishi_flg']);
                }else{
                    this.select_data.adminlist[i]['mendan_ishi_flg'] = 0;
                }

            }
        }
    }
    addRow(row:number) : void{
        let sss=
            { m_user_id: null,
                users_account: null,
                m_person_name: null,
                group:2
        };
        this.select_data.adminlist.splice(row+1, 0, sss); // i番目の次に１レコード追加
    }
    changeAdmin(row:number) : void{

        if(this.select_data.adminlist[row].group==2){
            this.select_data.adminlist[row].group=999;
        }else{
            this.select_data.adminlist[row].group=2;
        }
    }
    goBack(): void {
        this.location.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/a0120-contract-company/contract-company-list.component.ts